import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Record$dExtra from "../Record.Extra/index.js";
import * as Restaumatic$dCalendar$dTypes$dAvailability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId from "../Restaumatic.Menu.V2.Types.InternalParameterChoiceId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterId from "../Restaumatic.Menu.V2.Types.InternalParameterId/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
const toUnfoldable = /* #__PURE__ */ (() => {
  const $0 = Data$dUnfoldable.unfoldableArray.unfoldr(Data$dMap$dInternal.stepUnfoldr);
  return x => $0(Data$dMap$dInternal.$MapIter("IterNode", x, Data$dMap$dInternal.IterLeaf));
})();
const fromFoldable = /* #__PURE__ */ Data$dMap$dInternal.fromFoldable(Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.ordInternalParameterId)(Data$dFoldable.foldableArray);
const monoidMap = /* #__PURE__ */ Data$dMap$dInternal.monoidMap(Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.ordInternalParameterId);
const fold = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Specular$dFRP$dBase.monoidDynamic(monoidMap))(Data$dFoldable.identity))();
const rsequence = /* #__PURE__ */ Record$dExtra.sequenceRecord()(/* #__PURE__ */ Record$dExtra.sequenceRecordCons({reflectSymbol: () => "locale"})()(Specular$dFRP$dBase.applyDynamic)(/* #__PURE__ */ Record$dExtra.sequenceRecordCons({
  reflectSymbol: () => "params"
})()(Specular$dFRP$dBase.applyDynamic)(/* #__PURE__ */ Record$dExtra.sequenceRecordSingle({reflectSymbol: () => "schedules"})()(Specular$dFRP$dBase.functorDynamic)()())()())()());
const paymentMethod = menuEnv1 => {
  const v = Data$dMap$dInternal.lookup(Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.ordInternalParameterId)(Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.PaymentMethod)(menuEnv1.params);
  if (v.tag === "Just") {
    if (v._1.tag === "PaymentMethodChoice") { return Data$dMaybe.$Maybe("Just", v._1._1); }
    return Data$dMaybe.Nothing;
  }
  return Data$dMaybe.Nothing;
};
const menuEnv = catalogue => locale => localDateTimeD => fulfillmentMethodD => paymentMethodD => originD => {
  const schedules = Specular$dFRP$dBase.functorDynamic.map(localDateTime => Data$dMap$dInternal.functorMap.map(x => Restaumatic$dCalendar$dTypes$dAvailability.eqAvailabilityStatus.eq(Restaumatic$dCalendar$dTypes$dAvailability.availabilityStatus(x.availability)(localDateTime))(Restaumatic$dCalendar$dTypes$dAvailability.Available))(catalogue.availabilitySchedules))(localDateTimeD);
  return rsequence({
    locale: (() => {
      const n = Specular$dInternal$dIncremental.constant(locale);
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })(),
    params: fold([
      Specular$dFRP$dBase.functorDynamic.map(x => Data$dMap$dInternal.$$$Map(
        "Node",
        1,
        1,
        Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.Origin,
        Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.$InternalParameterChoiceId("OriginChoice", x),
        Data$dMap$dInternal.Leaf,
        Data$dMap$dInternal.Leaf
      ))(originD),
      Specular$dFRP$dBase.functorDynamic.map(v2 => {
        if (v2.tag === "Nothing") { return Data$dMap$dInternal.Leaf; }
        if (v2.tag === "Just") {
          return Data$dMap$dInternal.$$$Map(
            "Node",
            1,
            1,
            Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.FulfillmentMethod,
            Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.$InternalParameterChoiceId("FulfillmentMethodChoice", v2._1),
            Data$dMap$dInternal.Leaf,
            Data$dMap$dInternal.Leaf
          );
        }
        $runtime.fail();
      })(fulfillmentMethodD),
      Specular$dFRP$dBase.functorDynamic.map(v2 => {
        if (v2.tag === "Nothing") { return Data$dMap$dInternal.Leaf; }
        if (v2.tag === "Just") {
          return Data$dMap$dInternal.$$$Map(
            "Node",
            1,
            1,
            Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.PaymentMethod,
            Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.$InternalParameterChoiceId("PaymentMethodChoice", v2._1),
            Data$dMap$dInternal.Leaf,
            Data$dMap$dInternal.Leaf
          );
        }
        $runtime.fail();
      })(paymentMethodD),
      Specular$dFRP$dBase.functorDynamic.map((() => {
        const $0 = Data$dFunctor.arrayMap(v => Data$dTuple.$Tuple(
          Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.$InternalParameterId("Schedule", v._1),
          Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.$InternalParameterChoiceId("ScheduleChoice", v._2)
        ));
        return x => fromFoldable($0(x));
      })())(Specular$dFRP$dBase.functorDynamic.map(toUnfoldable)(schedules))
    ]),
    schedules
  });
};
const fulfillmentMethod = menuEnv1 => {
  const v = Data$dMap$dInternal.lookup(Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.ordInternalParameterId)(Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.FulfillmentMethod)(menuEnv1.params);
  if (v.tag === "Just") {
    if (v._1.tag === "FulfillmentMethodChoice") { return Data$dMaybe.$Maybe("Just", v._1._1); }
    return Data$dMaybe.Nothing;
  }
  return Data$dMaybe.Nothing;
};
const emptyMenuEnv = /* #__PURE__ */ (() => ({locale: Restaumatic$dLocales.PL, params: monoidMap.mempty, schedules: Data$dMap$dInternal.monoidMap(Data$dOrd.ordString).mempty}))();
export {emptyMenuEnv, fold, fromFoldable, fulfillmentMethod, menuEnv, monoidMap, paymentMethod, rsequence, toUnfoldable};
